import { WipState } from '../../state';

export const getWipPageKey = <S extends { wip: WipState }>(
  state: S,
): string | null => state.wip.pageKey;
